import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { createInquiry, createInquiryWithUserEnteredMedication } from '@api/inquiries';
import {
  ICreateInquiry,
  ICreateInquiryMedicationPayload,
  ICreateInquiryPayload,
} from '@interfaces/inquiries';

export const handleCreateInquiry = createAsyncThunk<
  AxiosResponse<ICreateInquiry>,
  ICreateInquiryPayload
>('createInquiry', createInquiry);

export const handleCreateInquiryWithUserEnteredMedication = createAsyncThunk<
  AxiosResponse<ICreateInquiry>,
  ICreateInquiryMedicationPayload
>('createInquiryWithUserEnteredMedication', createInquiryWithUserEnteredMedication);
